import { isDisabledOperation } from '@snap-types/features/alpha/import';
import type { AlphaOperationNoteKey } from '@snap-types/models/alpha-quote-line';
import type { LineItem } from '@snap-types/models/auto-configurator/state';
import {
  operationNoteKeys,
  operationNotes,
} from '@ui/features/alpha/config/operation-notes';

/**
 * Whether an apply would have an operation to write this note to. A line that
 * has not calculated yet knows nothing either way, which is different from
 * having calculated and come back without the operation.
 */
export type OperationNoteTarget =
  | { status: 'uncalculated' }
  | { status: 'present'; operation: string }
  | { status: 'absent' };

export function getOperationNoteTarget(
  lineItem: LineItem,
  key: AlphaOperationNoteKey,
): OperationNoteTarget {
  const { calculatedData } = lineItem;

  if (!calculatedData) {
    return { status: 'uncalculated' };
  }

  const operation = calculatedData[operationNotes[key].operationKey];

  if (isDisabledOperation(operation) || !operation) {
    return { status: 'absent' };
  }

  return { status: 'present', operation };
}

/**
 * Notes the line will never send: an apply skips the operation, so the note
 * stays here with nothing to carry it.
 */
export function getStrandedOperationNoteKeys(lineItem: LineItem) {
  return operationNoteKeys.filter(
    (key) =>
      !!lineItem[key].value &&
      getOperationNoteTarget(lineItem, key).status === 'absent',
  );
}

export function getOperationNoteLabel(key: AlphaOperationNoteKey) {
  return operationNotes[key].label;
}
